import api from './findSimilar.api'
import mediaPlayerApi from '../../MediaPlayer/mediaPlayer.api'
import { GET_SIMILAR_CONTACTS } from './findSimilar.constants'

export const getSimilarContacts = (contactId, numContacts, sessionId) => async dispatch => {
  dispatch({ type: GET_SIMILAR_CONTACTS.REQUESTED })
  try {
    const findSimilarResponse = await api.getFindSimilar(contactId, numContacts, sessionId)

    /*
    Comes in the form of
    {
        "formulaType": "TEXT",
        "values": [
            "1,2,3"
        ],
        "schemaName": "com.stytch.rest.api.v4.data.formula.CompileResultData"
    }
     */
    const contactIds =
      findSimilarResponse.values &&
      findSimilarResponse.values.length &&
      typeof findSimilarResponse.values[0] === 'string'
        ? findSimilarResponse.values[0].split(',')
        : []

    const exception = findSimilarResponse.exception ? findSimilarResponse.exception : false

    const similarContacts = await Promise.all(contactIds.map(contactId => mediaPlayerApi.getContact(contactId)))

    if (exception) {
      dispatch({
        error: exception,
        type: GET_SIMILAR_CONTACTS.FAILURE,
      })
    } else {
      dispatch({
        response: similarContacts,
        type: GET_SIMILAR_CONTACTS.SUCCESS,
      })
    }

    return similarContacts
  } catch (error) {
    dispatch({
      error,
      type: GET_SIMILAR_CONTACTS.FAILURE,
    })

    throw error
  }
}
